import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { socket } from 'api';
import { stopSound } from 'store/actions/sounds';
import { dropCall } from 'store/actions/calls';
import { CallButton, DropButton } from './buttons/buttons';
import { Content } from './call-buttons.styled';
import { Voice } from './voice';

const testVoice = false;

export const CallButtons = (props) => {
  const { rackId, style, small } = props;
  let voice = useSelector((store) => store.equipment[rackId]?.voice);
  if (testVoice && (!voice || (voice && voice?.phones?.length < 2))) {
    voice = {
      phones: ['Test1', 'Test2'],
    };
  }
  const [phone, setPhone] = useState(voice?.phones && voice?.phones.length > 0 ? voice?.phones[0] : '');
  const call = useSelector((state) => state.calls.calls[rackId]);
  // console.log("call", rackId, call);
  const dispatch = useDispatch();

  const rightCall = window.haveRight('mnemo.calls');
  if (!rightCall) {
    return null;
  }

  /**
   * stop sound
   */
  const doStopSound = () => {
    try {
      dispatch(stopSound('call'));
    } catch (__error) {}
  };

  /**
   * make call
   * @returns
   */
  const makeCall = () => {
    doStopSound();

    if (call) {
      socket.call('call_answer', call, () => {
        window.addActiveCall(rackId);
      });
      return;
    }

    const out = { target: rackId };
    if (phone) {
      out.src = phone;
    }
    socket.call('call_create', out, () => {
      window.addActiveCall(rackId);
    });
  };

  /**
   * cancel call
   */
  const cancelCall = () => {
    doStopSound();

    const isActive = window.isActiveCall(rackId);

    if (isActive) {
      socket.call('call_end', {
        id: call.id,
        target: call.source_inner_id,
      });
    } else {
      socket.call('call_reject', {
        id: call.id,
        source: call.source_inner_id,
      });
    }
    dispatch(dropCall(call.id));
  };

  const change = (event) => setPhone(event.target.value);

  return (
    <Content style={style} $small={small}>
      {voice?.phones && voice?.phones.length > 1 && <Voice voice={voice} value={phone} change={change} />}
      <CallButton action={makeCall}></CallButton>
      {call && <DropButton action={cancelCall}></DropButton>}
    </Content>
  );
};
